import styled, { css } from 'styled-components';

// Constellation Components
import {
    FormHelp,
    Label,
    Spacer,
    Text,
} from '@zillow/constellation';

import {
    Col,
    Link,
} from '@zillow/zrs-comet';

export const StyledAddressInfoText = styled(Text)`
    display: none;

    ${props => props.theme.ns().media.lg(css`
        display: inline-block;
    `)};
`;

export const StyledCenterText = styled(Text)`
    text-align: center;
`;

export const StyledDeleteCol = styled(Col)`
    line-height: 24px;
`;

export const StyledDisplayLayoutDiv = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const StyledDropdownSpacer = styled(Spacer)`
    display: inline-block;
    color: #888888;
    font-size: 10px;
    letter-spacing: 1px;
    top: 4px;
    position: relative;
    width: 20px;
    float: right;
    ${props => props.theme.ns().media.lg(css`
        font-size: 14px;
        letter-spacing: 1px;
        width: 25px;
    `)};
`;

export const StyledDropzoneContainerDiv = styled.div`
    display: flex;
    flex-flow: column;
    min-height: 194px;
    flex: 1;

    .DropzoneContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

/* set opacity to 0 until there is a design */
export const StyledImageCoverDiv = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #222;
    opacity: 0;
    z-index: 9999;
`;

export const StyledImageSpacer = styled(Spacer)`
    position: relative;

    :nth-child(odd) {
        background-color: #F2F2F2;
        min-height: 140px;
    }
`;

export const StyledFloorplansBarSpacer = styled(Spacer)(({
    borderBottom,
}) => css`
    cursor: pointer;
    ${!borderBottom && css`
        height: 36px;
        border-bottom: 1px solid #eee;
    `}
`);

export const StyledFormHelp = styled(FormHelp)`
    display: inline;
`;

export const StyledLayoutContainerSpacer = styled(Spacer)`
    flex: 1;
`;

export const StyledRemoveLayoutLink = styled(Link)`
    float: right;
`;

export const StyledToggleViewLink = styled(Link)`
    ${props => props.theme.ns().media.md(css`
            float: right;
            position: relative;
            top: 10px;
    `)};
`;

export const StyledMediaCol = styled(Col)`
    display: flex;
    flex-direction: column;
    ${props => props.theme.ns().media.lg(css`
        flex-direction: row;
    `)};
`;

export const StyledUploadLayoutContainerDiv = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
`;

export const StyledLabelTitle = styled(Label)`
    padding-top: ${props => props.theme.ns().spacing.sm()};
`;

export const StyledLabel = styled(Label)((props) => {
    const color = props.disabled ? '#736F7C' : props.theme.ns().colors.textDark;

    return {
        color,
    };
});
